import { ReactNode } from 'react';

import { DrawerProvider, Stack } from '@cast/design-system';

import { InventoryWorkloadDetailsProvider } from './_components/InventoryWorkloadDetailsProvider';
import { InventoryWorkloadDetailsHeader } from './_components/InventoryWorkloadDetailsHeader';
import { InventoryWorkloadPolicyCard } from './_components/InventoryWorkloadPolicyCard';
import { InventoryWorkloadSavingsDifferenceCard } from './_components/InventoryWorkloadSavingsDifferenceCard';

type Props = {
  children: ReactNode;
};

export const InventoryWorkloadDetailsLayout = ({ children }: Props) => (
  <InventoryWorkloadDetailsProvider>
    <DrawerProvider>
      <Stack gap={16}>
        <InventoryWorkloadDetailsHeader />
        {/*
          WOOP-2169 C1 (Figma Phase-1 node 5709-145102): header row should also
          include an Attention Needed card. No workload-scoped attention API exists
          yet (fleet dashboard omits it in WORKLOADS_DASHBOARD_DEFAULT_VISIBLE).
        */}
        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          gap={16}
          alignItems="stretch"
        >
          <Stack flex={1} minWidth={0}>
            <InventoryWorkloadPolicyCard />
          </Stack>
          <Stack flex={1} minWidth={0}>
            <InventoryWorkloadSavingsDifferenceCard />
          </Stack>
        </Stack>
        {children}
      </Stack>
    </DrawerProvider>
  </InventoryWorkloadDetailsProvider>
);
